<mat-card appearance="outlined" class="default-card">
    <mat-card-header>
        <mat-card-title>Supervision</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="container">
            <div class="form-container">
                <div class="form-item">
                    <mat-form-field style="width: 300px">
                        <mat-select [disabled]="false" placeholder="Vue" (selectionChange)="onWorkflowChange($event)">
                            @for (view of views; track view.id) {
                                <mat-option [value]="view.id">{{ view.name }}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </div>

                <div class="form-item">
                    <mat-form-field style="width: 300px">
                        <mat-select [disabled]="false" placeholder="Type de dashboard" (selectionChange)="onDashboardChange($event)">
                            <mat-option value="Wokflow_delay">Respect des délais par étape</mat-option>
                            <mat-option value="Wokflow_average_time">Délais moyen par étape</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <div class="form-item">
                    <mat-form-field style="width: 300px">
                        <mat-select [disabled]="false" placeholder="Etapes à prendre en compte" (selectionChange)="onStepTypeChange($event)">
                            <mat-option [value]="DashboardWorkflowStepState.All">Toutes</mat-option>
                            <mat-option [value]="DashboardWorkflowStepState.CompletedSteps">Uniquement les étapes terminées</mat-option>
                            <mat-option [value]="DashboardWorkflowStepState.StartedSteps">Uniquement les étapes en cours de traitement.</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            @if (histoChart) {
                <div id="histochart">
                    <apx-chart
                        [series]="histoChart.series"
                        [chart]="histoChart.chart"
                        [dataLabels]="histoChart.dataLabels"
                        [responsive]="histoChart.responsive"
                        [fill]="histoChart.fill"
                        [colors]="histoChart.colors"
                        [legend]="histoChart.legend"
                        [plotOptions]="histoChart.plotOptions"
                        [xaxis]="histoChart.xaxis"
                        [yaxis]="histoChart.yaxis"
                        [title]="histoChart.title"
                        [theme]="histoChart.theme"></apx-chart>
                </div>
            }

            <ngx-spinner name="supervision-spinner" [fullScreen]="false" type="timer" size="medium"></ngx-spinner>
        </div>
    </mat-card-content>
    <mat-card-actions>
        <button mat-stroked-button class="accent-button" style="visibility: hidden">Annuler</button>
        <button mat-raised-button class="accent-button" (click)="close()">Ok</button>
    </mat-card-actions>
</mat-card>
